/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FlexColumn, FlexRow } from '../GridsAndLayouts';
import Typography from '../Typography';
import './FeedTimeline.scss';

const FeedTimelineItem = ({
  icon,
  iconBackground,
  lead,
  highlight,
  timestamp,
  showConnectorBelow = false,
  className = '',
  ...rest
}) => (
  <FlexRow className={classNames('ds-feed-timeline-item', className)} align="center" gap={8} fullWidth {...rest}>
    <FlexColumn className="ds-feed-timeline-item__rail" align="center" inline fullWidth={false}>
      <FlexRow
        className="ds-feed-timeline-item__icon"
        align="center"
        justify="center"
        inline
        fullWidth={false}
        style={{ background: iconBackground }}
      >
        {icon}
      </FlexRow>
      {showConnectorBelow ? (
        <FlexColumn className="ds-feed-timeline-item__connector" aria-hidden inline fullWidth={false} />
      ) : null}
    </FlexColumn>
    <FlexRow className="ds-feed-timeline-item__main" align="center" justify="start" fullWidth>
      <FlexRow className="ds-feed-timeline-item__text" align="center" wrap gap={3} fullWidth>
        {lead != null && lead !== '' ? (
          <Typography component="div" variant="bodyExtraMedium" className="ds-feed-timeline-item__lead">
            {lead}
          </Typography>
        ) : null}
        {highlight != null && highlight !== '' ? (
          <Typography
            component="div"
            variant="bodyExtraMedium"
            fontWeight="medium"
            className="ds-feed-timeline-item__highlight"
          >
            {highlight}
          </Typography>
        ) : null}
      </FlexRow>
      {timestamp != null && timestamp !== '' ? (
        <Typography component="div" variant="bodyExtraSmall" className="ds-feed-timeline-item__time">
          {timestamp}
        </Typography>
      ) : null}
    </FlexRow>
  </FlexRow>
);

FeedTimelineItem.propTypes = {
  icon: PropTypes.node.isRequired,
  iconBackground: PropTypes.string.isRequired,
  lead: PropTypes.node,
  highlight: PropTypes.node,
  timestamp: PropTypes.node,
  showConnectorBelow: PropTypes.bool,
  className: PropTypes.string,
};

const FeedTimeline = ({ items, className = '', ...rest }) => (
  <FlexColumn className={classNames('ds-feed-timeline', className)} align="stretch" fullWidth {...rest}>
    {items.map((item, i) => (
      <FeedTimelineItem
        key={item.key ?? i}
        {...item}
        showConnectorBelow={item.showConnectorBelow ?? i < items.length - 1}
      />
    ))}
  </FlexColumn>
);

const itemShape = PropTypes.shape({
  key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  icon: PropTypes.node.isRequired,
  iconBackground: PropTypes.string.isRequired,
  lead: PropTypes.node,
  highlight: PropTypes.node,
  timestamp: PropTypes.node,
  showConnectorBelow: PropTypes.bool,
});

FeedTimeline.propTypes = {
  items: PropTypes.arrayOf(itemShape).isRequired,
  className: PropTypes.string,
};

export { FeedTimeline, FeedTimelineItem };
export default FeedTimeline;
